import React, { useEffect, useState } from "react";

import { useTranslation } from "react-i18next";
import { FrontendUserInfo, FrontendOrder } from "node-library/dist/portal";
import { Card, Divider } from "@mui/material";
import { OrderTableSortColumn, SortOrder } from "node-library/dist/paginations";
import { NeutralColor, PrimaryColor } from "node-library/dist/colors";
import {
	FolderIcon,
	SortArrowIcon,
} from "../../../../common-components/svgIcons";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";

import { NavBar } from "../../../../common-components/navbar";
import { Severity, TurnaroundTime } from "node-library/dist/constants";
import { getOrderAvailableTAT } from "../../../../helpers/orderHelper";
import { getShortTurnaroundTime } from "../../../../helpers/sampleHelper";
import { CustomRadioGroup } from "../../../../common-components/inputs";
import {
	BlackButton,
	CustomIconButton,
	GreenButton,
	KebabDropdownButton,
} from "../../../../common-components/button";
import {
	sendGETRequest,
	sendPOSTRequest,
} from "../../../../requestHelper/sendRequest";
import {
	RedErrorIcon,
	RedTrashIcon,
} from "../../../../common-components/toast/errorIcons";
import { useSnackbar } from "../../../../common-components/toast/showToastMessage";
import UploadTestReportModal from "./uploadTestReportModal";
import { formatCustomDate } from "node-library/dist/helpers/date_helper";
import { GreenTickIcon } from "../../../../common-components/toast/successIcons";
import DeleteTestReportConfirmModal from "../../../../common-components/modals/deleteTestReportConfirmModal";
import ClientOrderReportPageSkeletonUI from "../skeletonUI/clientOrderReportPageSkeleton";
import { handleDownloadAll } from "../../../../helpers/frontendFileOperationHelper";

interface Props {
	selectedOrder: FrontendOrder;
	goBackToViewOrdersPage: (reload: boolean) => void;

	gotoOrderDetailsPage: () => void;
}

export default function AdminViewOrderReportPage(props: Props) {
	// const { t: translation } = useTranslation();
	// const { openSnackbar } = useSnackbar();

	// const { selectedOrder, goBackToViewOrdersPage, gotoOrderDetailsPage } = props;
	// const orderTAT: Array<TurnaroundTime> = getOrderAvailableTAT(selectedOrder);

	// const [loading, setLoading] = useState<boolean>(false);
	// const [selectedFolder, setSeletedFolder] = useState<TurnaroundTime>(
	// 	orderTAT[0]
	// );
	// const [testReports, setTestReports] = useState<Array<FrontendTestReport>>([]);

	// const [uploadModalOpen, setUploadModalOpen] = useState<boolean>(false);
	// const [deleteReportModalOpen, setDeleteReportModalOpen] =
	// 	useState<boolean>(false);

	// const [proceedAction, setProceedAction] = useState<() => void>(
	// 	() => () => {}
	// );

	// const testReportsInFolder: Array<FrontendTestReport> = testReports
	// 	.filter((report) => {
	// 		return report.turnaroundTime == selectedFolder;
	// 	})
	// 	.sort((a, b) => {
	// 		if (a.clientDownloaded === null && b.clientDownloaded !== null) {
	// 			return -1; // a comes first
	// 		} else if (a.clientDownloaded !== null && b.clientDownloaded === null) {
	// 			return 1; // b comes first
	// 		} else {
	// 			return (
	// 				new Date(b.inserted as Date).getTime() -
	// 				new Date(a.inserted as Date).getTime()
	// 			); // descending order
	// 		}
	// 	});

	// async function getOrderTestReports() {
	// 	setLoading(true);
	// 	try {
	// 		const response = await sendGETRequest("/test-reports/get-order-reports", {
	// 			orderId: selectedOrder.orderId,
	// 		});

	// 		const reports: Array<FrontendTestReport> = response?.data?.reports;
	// 		setTestReports(reports);
	// 	} catch (error: any) {
	// 		console.error(error);
	// 		openSnackbar(
	// 			translation("SystemError"),
	// 			Severity.ERROR,
	// 			translation("SystemErrorMsg"),
	// 			<RedErrorIcon />
	// 		);
	// 	} finally {
	// 		setLoading(false);
	// 	}
	// }

	// async function moveReportToFolder(reportId: string, folder: TurnaroundTime) {
	// 	setLoading(true);
	// 	try {
	// 		const response = await sendPOSTRequest("/test-reports/move-test-report", {
	// 			reportId,
	// 			folder,
	// 		});

	// 		setTestReports((prevReports) =>
	// 			prevReports.map((prevReport, idx) =>
	// 				prevReport.reportId === reportId
	// 					? { ...prevReport, turnaroundTime: folder }
	// 					: prevReport
	// 			)
	// 		);

	// 		openSnackbar(
	// 			translation("ReportMovedSuccess"),
	// 			Severity.SUCCESS,
	// 			undefined,
	// 			<GreenTickIcon />
	// 		);
	// 	} catch (error: any) {
	// 		console.error(error);
	// 		openSnackbar(
	// 			translation("SystemError"),
	// 			Severity.ERROR,
	// 			translation("SystemErrorMsg"),
	// 			<RedErrorIcon />
	// 		);
	// 	} finally {
	// 		setLoading(false);
	// 	}
	// }

	// async function deleteTestReport(reportId: string) {
	// 	setLoading(true);
	// 	try {
	// 		const response = await sendPOSTRequest(
	// 			"/test-reports/delete-test-report",
	// 			{
	// 				reportId,
	// 			}
	// 		);

	// 		setTestReports((prevReports) =>
	// 			prevReports.filter((report) => report.reportId !== reportId)
	// 		);

	// 		openSnackbar(
	// 			translation("ReportDeleted"),
	// 			Severity.ERROR,
	// 			undefined,
	// 			<RedTrashIcon />
	// 		);
	// 	} catch (error: any) {
	// 		console.error(error);
	// 		openSnackbar(
	// 			translation("SystemError"),
	// 			Severity.ERROR,
	// 			translation("SystemErrorMsg"),
	// 			<RedErrorIcon />
	// 		);
	// 	} finally {
	// 		setLoading(false);
	// 	}
	// }

	// async function downloadTestReports(reportIds: Array<string>) {
	// 	setLoading(true);
	// 	try {
	// 		const response = await sendPOSTRequest(
	// 			"/test-reports/download-test-reports",
	// 			{
	// 				reportIds,
	// 				orderId: selectedOrder.orderId,
	// 			}
	// 		);
	// 		const fileAndSignedURLs: Array<{
	// 			fileName: string;
	// 			format: string;
	// 			signedURL: string;
	// 		}> = response.data.fileAndsignedURLs;

	// 		const downloadResults: Array<{
	// 			fullName: string;
	// 			success: boolean;
	// 		}> = await handleDownloadAll(fileAndSignedURLs);

	// 		const errorFiles: Array<{
	// 			fullName: string;
	// 			success: boolean;
	// 		}> = downloadResults.filter((result) => {
	// 			return result.success == false;
	// 		});

	// 		if (errorFiles.length === 0) {
	// 			// openSnackbar(
	// 			// 	translation("SomeReportDownloaded", {
	// 			// 		count: downloadResults.length,
	// 			// 	}),
	// 			// 	Severity.SUCCESS,
	// 			// 	undefined,
	// 			// 	<GreenTickIcon />
	// 			// );
	// 		} else {
	// 			openSnackbar(
	// 				translation("SomeReportDownloadedFailed", {
	// 					count: downloadResults.length,
	// 				}),
	// 				Severity.ERROR,
	// 				translation("SomeReportDownloadedFailedMsg", {
	// 					files: errorFiles
	// 						.map((file) => {
	// 							return file.fullName;
	// 						})
	// 						.join(", "),
	// 				}),
	// 				<RedErrorIcon />
	// 			);
	// 		}
	// 	} catch (error: any) {
	// 		console.error(error);
	// 		openSnackbar(
	// 			translation("SystemError"),
	// 			Severity.ERROR,
	// 			translation("SystemErrorMsg"),
	// 			<RedErrorIcon />
	// 		);
	// 	} finally {
	// 		setLoading(false);
	// 	}
	// }

	// useEffect(() => {
	// 	getOrderTestReports();
	// 	setSeletedFolder(orderTAT[0]);
	// }, [selectedOrder]);

	// const navbarItems: Array<{
	// 	label: string;
	// 	onClick: () => void;
	// 	isCurrentItem: boolean;
	// }> = [
	// 	{
	// 		label: translation("Orders"),
	// 		onClick: () => goBackToViewOrdersPage(true),
	// 		isCurrentItem: false,
	// 	},
	// 	{
	// 		label: translation("OrderDetails"),
	// 		onClick: () => {
	// 			gotoOrderDetailsPage();
	// 		},
	// 		isCurrentItem: false,
	// 	},
	// 	{
	// 		label: translation("Reports"),
	// 		onClick: () => {},
	// 		isCurrentItem: true,
	// 	},
	// ];

	// const orderDetailsHeaderRow: React.ReactNode = (
	// 	<div
	// 		style={{
	// 			display: "flex",
	// 			justifyContent: "space-between",
	// 			alignItems: "center",
	// 			gap: "10px",
	// 			flexWrap: "wrap",
	// 		}}
	// 	>
	// 		<div>
	// 			<div style={{ marginLeft: "35px" }}>
	// 				<NavBar items={navbarItems}></NavBar>
	// 			</div>

	// 			<div style={{ display: "flex", gap: "5px", alignItems: "center" }}>
	// 				<CustomIconButton
	// 					id="admin-view-report-back-button"
	// 					size="small"
	// 					onClick={() => {
	// 						gotoOrderDetailsPage();
	// 					}}
	// 					icon={<KeyboardArrowLeftIcon />}
	// 				></CustomIconButton>

	// 				<div className="typography-heading-01">
	// 					{translation("TestReports")}
	// 				</div>
	// 			</div>
	// 		</div>
	// 	</div>
	// );

	// const iconCardRadioOptions: Array<{
	// 	key: string;
	// 	name: string;
	// 	value: any;
	// 	children?: React.ReactNode;
	// }> = orderTAT.map((tat: TurnaroundTime) => {
	// 	const tatString: string = getShortTurnaroundTime(tat, translation);
	// 	return {
	// 		key: tat,
	// 		name: tatString,
	// 		value: tat,
	// 		children: (
	// 			<Card
	// 				className={`card-normal-padding ${
	// 					selectedFolder === tat ? "card-radio-checked" : ""
	// 				} `}
	// 				tabIndex={0}
	// 			>
	// 				<div className={`test-report-folder-icon-container`}>
	// 					<FolderIcon></FolderIcon>
	// 				</div>

	// 				<div
	// 					className="typography-body-01 overflow-ellipsis-text"
	// 					style={{ margin: "5px 2px" }}
	// 				>
	// 					{tatString}
	// 					<div
	// 						className="typography-caption"
	// 						style={{ color: NeutralColor.NEUTRAL_GREY_500 }}
	// 					>
	// 						{`${
	// 							testReports.filter((report) => {
	// 								return report.turnaroundTime == tat;
	// 							}).length
	// 						} ${translation("Reports")}`}
	// 					</div>
	// 				</div>
	// 			</Card>
	// 		),
	// 	};
	// });

	// const folderContainer: React.ReactNode = (
	// 	<div>
	// 		<div className="typography-body-01" style={{ marginBottom: "10px" }}>
	// 			{translation("TestReportsByTAT")}
	// 		</div>
	// 		<CustomRadioGroup
	// 			className="test-report-card-radio-group"
	// 			options={iconCardRadioOptions}
	// 			selectedOption={selectedFolder}
	// 			onChange={(e) => {
	// 				setSeletedFolder(e.target.value);
	// 			}}
	// 		/>
	// 	</div>
	// );

	// const folderContentContainer: React.ReactNode = (
	// 	<Card className="card-normal-padding">
	// 		<div className="test-report-folder-contant-header">
	// 			<div>
	// 				<div
	// 					style={{
	// 						display: testReportsInFolder.length == 0 ? "none" : "initial",
	// 					}}
	// 				>
	// 					<BlackButton
	// 						key="test-report-download-folder-button"
	// 						id="test-report-download-folder-button"
	// 						children={translation("DownloadAll")}
	// 						onClick={() => {
	// 							downloadTestReports(
	// 								testReportsInFolder.map((report) => {
	// 									return report.reportId;
	// 								})
	// 							);
	// 						}}
	// 					></BlackButton>
	// 				</div>
	// 			</div>

	// 			<GreenButton
	// 				key="test-report-upload-button"
	// 				id="test-report-upload-button"
	// 				children={translation("Upload")}
	// 				onClick={() => {
	// 					setUploadModalOpen(true);
	// 				}}
	// 			></GreenButton>
	// 		</div>
	// 		<div style={{ marginTop: "20px" }}>
	// 			{testReportsInFolder.length == 0 && (
	// 				<div className="typography-heading-02 no-reports-container">
	// 					{translation("NoReportsAvailable")}
	// 				</div>
	// 			)}
	// 			{testReportsInFolder.map((report) => {
	// 				const submenuOptions = Object.values(TurnaroundTime)
	// 					.filter((tat) => {
	// 						return tat !== selectedFolder && orderTAT.includes(tat);
	// 					})
	// 					.map((time) => {
	// 						return {
	// 							key: `${report.reportId}-to-${time}`,
	// 							onClick: () => {
	// 								moveReportToFolder(report.reportId, time);
	// 							},
	// 							children: (
	// 								<div className="icon-dropdown-menu-item">
	// 									{getShortTurnaroundTime(time, translation)}
	// 								</div>
	// 							),
	// 						};
	// 					});
	// 				return (
	// 					<div style={{ margin: "5px" }} key={report.reportId}>
	// 						<div className="order-test-report-item-row">
	// 							<div style={{ maxWidth: "80%" }}>
	// 								<div
	// 									className="typography-caption"
	// 									style={{ color: PrimaryColor.PRIMARY_600 }}
	// 								>
	// 									{`${translation("Uploadedon")}: ${formatCustomDate(
	// 										report.inserted as Date
	// 									)}`}
	// 								</div>
	// 								<div className="typography-body-02 overflow-ellipsis-text">
	// 									{`${report.fileName}.${report.format}`}
	// 								</div>
	// 							</div>
	// 							<div>
	// 								<KebabDropdownButton
	// 									menuOptions={[
	// 										...(submenuOptions.length > 0
	// 											? [
	// 													{
	// 														key: `move-folder-${report.reportId}`,
	// 														onClick: () => {},
	// 														children: (
	// 															<div className="icon-dropdown-menu-item icon-dropdown-submenu-containing-item ">
	// 																{translation("Moveto")}
	// 																<KeyboardArrowRightIcon />
	// 															</div>
	// 														),
	// 														hasSubmenu: true,
	// 														submenuOptions: submenuOptions,
	// 													},
	// 											  ]
	// 											: []),
	// 										{
	// 											key: `download-report-${report.reportId}`,
	// 											onClick: () => {
	// 												downloadTestReports([report.reportId]);
	// 											},
	// 											children: (
	// 												<div className="icon-dropdown-menu-item">
	// 													{translation("Download")}
	// 												</div>
	// 											),
	// 										},
	// 										{
	// 											key: `delete-report-${report.reportId}`,
	// 											onClick: () => {
	// 												setProceedAction(() => () => {
	// 													deleteTestReport(report.reportId);
	// 												});
	// 												setDeleteReportModalOpen(true);
	// 											},
	// 											children: (
	// 												<div className="icon-dropdown-menu-item">
	// 													{translation("Delete")}
	// 												</div>
	// 											),
	// 										},
	// 									]}
	// 									id={`report-more-action-menu-${report.reportId}`}
	// 									onClick={(e) => {}}
	// 								></KebabDropdownButton>
	// 							</div>
	// 						</div>
	// 						<Divider orientation="horizontal" flexItem></Divider>
	// 					</div>
	// 				);
	// 			})}
	// 		</div>
	// 	</Card>
	// );

	// return loading ? (
	// 	<ClientOrderReportPageSkeletonUI />
	// ) : (
	// 	<div>
	// 		{orderDetailsHeaderRow}

	// 		<div
	// 			style={{
	// 				margin: "60px auto",
	// 				width: "70%",
	// 				maxWidth: "900px",
	// 				display: "flex",
	// 				flexDirection: "column",
	// 				gap: "15px",
	// 			}}
	// 		>
	// 			{folderContainer}
	// 			{folderContentContainer}
	// 		</div>
	// 		<UploadTestReportModal
	// 			open={uploadModalOpen}
	// 			setOpen={setUploadModalOpen}
	// 			selectedOrder={selectedOrder}
	// 			currentFolder={selectedFolder}
	// 			currentFolderReports={testReportsInFolder}
	// 			setTestReports={setTestReports}
	// 		></UploadTestReportModal>

	// 		<DeleteTestReportConfirmModal
	// 			open={deleteReportModalOpen}
	// 			setOpen={setDeleteReportModalOpen}
	// 			proceedAction={proceedAction}
	// 		></DeleteTestReportConfirmModal>
	// 	</div>
	// );
	return <></>;
}
